import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { ProjectAssigneesWithUserInfoDto } from '../../commonTypes/project.types';

export interface AssigneesState {
    projectAssignees: Record<string, ProjectAssigneesWithUserInfoDto[]>;
}

const initialState: AssigneesState = {
    projectAssignees: {},
};

const projectAssigneesSlice = createSlice({
    name: 'projectAssignees',
    initialState,
    reducers: {
        setProjectAssignees: (state, { payload: { projectId, assignees } }) => {
            state.projectAssignees[projectId] = assignees;
        },
        invalidateProjectAssignees: (state, { payload: projectId }) => {
            delete state.projectAssignees[projectId];
        },
        addProjectAssignees: (state, { payload: { projectId, newAssignees } }) => {
            if (newAssignees.length) {
                state.projectAssignees[projectId] = state.projectAssignees[projectId]
                    ? [...state.projectAssignees[projectId], ...newAssignees]
                    : newAssignees;
            }
        },
        updateAssignee: (state, { payload }) => {
            const { projectId, userSub, updates } = payload;
            const projectAssignees = state.projectAssignees[projectId];
            if (projectAssignees) {
                state.projectAssignees[projectId] = projectAssignees.map(assignee =>
                    assignee.userSub === userSub
                        ? {
                              ...assignee,
                              ...(updates ?? {}),
                          }
                        : assignee
                );
            }
        },
    },
});

export const { setProjectAssignees, invalidateProjectAssignees, addProjectAssignees, updateAssignee } = projectAssigneesSlice.actions;

export const selectProjectAssignees = (state: RootState, projectId: string) => state.projectAssignees.projectAssignees[projectId] || [];

export default projectAssigneesSlice.reducer;
